export default __webpack_public_path__ + "static/whitepaper-interest-free-f962bd9fee1c5023c01b3cf711a2b4e0.webp";